import React, { useEffect, useCallback, useRef, useState, useMemo, memo, Suspense, lazy, ReactNode } from 'react';
import { Button, Dimensions, Linking, Modal, View, ScrollView, LayoutChangeEvent, Text, StyleSheet, ProgressBarAndroidBase } from 'react-native';

import { useFocusEffect } from '@react-navigation/native';

//import Pdf from 'react-native-pdf';
import { trackMatomoBrowsing, trackMatomoInterstitial } from '../matomo/tracker';
//import * as FileSystem from 'expo-file-system';
import { router, useLocalSearchParams } from 'expo-router';
import { emitEvent, addEventListener, removeAllEventListeners } from '@/services/EventService';
import { useBoundStore, usePersistSecureBoundStore } from '@/services/zustand/Store.web';

///// For web only - Start \\\\\
import { Magazine, InterJSON } from '@/services/Datatypes.web';

import ArticleModal from '@/components/ArticleModal.web';

// node
import * as path from 'path';
import * as appRootPath from 'app-root-path';
import * as Buffer from 'buffer';

// react
import 'keen-slider/keen-slider.min.css';
import '@/components/styles/webKeenSlider.css';
import { useKeenSlider, KeenSliderPlugin } from 'keen-slider/react';

const MutationPlugin: KeenSliderPlugin = (slider) => {
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            slider.update()
        })
    });
    const config = { childList: true }
  
    slider.on("created", () => {
        observer.observe(slider.container, config)
    });

    slider.on("destroyed", () => {
        observer.disconnect()
    });
};


// expo
import { Asset, useAssets } from 'expo-asset';

// react bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import Carousel from 'react-bootstrap/Carousel';

// pdf.js
import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { transform } from '@babel/core';
import { Float } from 'react-native/Libraries/Types/CodegenTypes';

const origin = window.location.origin;

pdfjs.GlobalWorkerOptions.workerSrc = `${origin}/pdf.worker.min.js`;


const options = {
    cMapUrl: `${origin}/cmaps/`,
    standardFontDataUrl: `${origin}/fonts/`,
    enableHWA: true,
    httpHeaders: {
        "x-api-key": "d85ed5ba-b8f9-459a-b60d-37863f696a7e"
    }
}

///// For web only - End \\\\\

interface ViewerComponentProps {
    magazine: Magazine;
    interstitialData: InterJSON | null;
}

// Components

const PageComponent = lazy(() => import('@/components/PageComponent.web'));

const Arrow = (props: {
    disabled: boolean
    left?: boolean
    onClick: (e: any) => void
}) => {
    const disabled = props.disabled ? " arrow--disabled" : ""
    return (
        <svg
            onClick={props.onClick}
            className={`arrow ${
                props.left ? "arrow--left" : "arrow--right"
            } ${disabled}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
        {props.left && (
            <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
        )}
        {!props.left && (
            <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
        )}
        </svg>
    );
};

const SliderControlComponent = (props: {
    instanceRef: any,
    numPages: any,
}) => {

    const currentPage: number = useBoundStore(useCallback((state) => state.currentPage, []));

    //const currentPage: number = 1;

    return(
        <>
            <Arrow
                left
                onClick={(e: any) =>
                    e.stopPropagation() || props.instanceRef.current?.prev()
                }
                disabled={(currentPage - 1) === 0}
            />

            <Arrow
                onClick={(e: any) =>
                    e.stopPropagation() || props.instanceRef.current?.next()
                }
                
                disabled={
                    //currentSlide === instanceRef.current?.track.details.slides.length - 1
                    (currentPage - 1) === (props.numPages - 1)
                }
                //style={[styles.arrow]}
            />
        </>
        
    );

};

export const getMagazinePage = async (date: string, edition: string, pageNo: number) => {

    return new Promise(async (resolve, reject) => {

        const magazineSource: any = await fetch(
            '/web-server-api/getPdfAsBase64',
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "date": date,
                    "edition": edition,
                    "pageNo": pageNo,
                    "type": 'singlePage'
                }),
            }
        );

        const data = await magazineSource.json();

        const pdfBinaryData = data.pdfBinaryData;
        const length = pdfBinaryData.length;
        let response = new Uint8Array(length);

        for (var i = 0; i < length; i++) {
            const ascii = pdfBinaryData.charCodeAt(i);
            response[i] = ascii;

            if(i === (length - 1)) {
                resolve(response);
            }
        }
        
    });

    
};

export const getMagazinSource = async (date: any, edition: any) => {

    return new Promise(async (resolve, reject) => {
        
        const magazineSource: any = await fetch(
            '/web-server-api/getPdfAsBase64',
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "date": date,
                    "edition": edition,
                    "type": 'allPages'
                }),
            }
        );

        const data = await magazineSource.json();

        const pdfBinaryData = data.pdfBinaryData;
        const length = pdfBinaryData.length;
        let response = new Uint8Array(length);

        for (var i = 0; i < length; i++) {
            const ascii = pdfBinaryData.charCodeAt(i);
            response[i] = ascii;

            if(i === (length - 1)) {
                resolve(response);
            }
        }

    });

    
};

export const getArticleJson = async (date: any, edition: any) => {

    return new Promise(async (resolve, reject) => {

        const articleJsonData: any = await fetch(
            '/web-server-api/getJson',
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "date": date,
                    "edition": edition
                }),
            }
        );

        const data = await articleJsonData.json();
        
        if(data) {
            resolve(data);
        }
        else {
            reject('no_data');
        }

    });

};

export const savePdfAsHtml = async (date: any, edition: any, content: any) => {

    return new Promise(async (resolve, reject) => {

        const savePdfAsHtml: any = await fetch(
            '/web-server-api/savePdfAsHtml',
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "date": date,
                    "edition": edition,
                    "data": content,
                }),
            }
        );

        const data = await savePdfAsHtml.json();
        
        if(data.response) {
            resolve(data.response);
        }
        else {
            reject(false);
        }

    });

};

// checkIfPdfHtmlExists
export const checkIfPdfHtmlExists = async (date: any, edition: any) => {

    return new Promise(async (resolve, reject) => {

        const checkIfPdfHtmlExists: any = await fetch(
            '/web-server-api/checkIfPdfHtmlExists',
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "date": date,
                    "edition": edition,
                }),
            }
        );

        const data = await checkIfPdfHtmlExists.json();

        if(data.response) {
            resolve(data.response);
        }
        else {
            reject(false);
        }

    });

};

// getPdfAsHtml
export const getPdfAsHtml = async (date: any, edition: any) => {

    return new Promise(async (resolve, reject) => {

        const getPdfAsHtml: any = await fetch(
            '/web-server-api/getPdfAsHtml',
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "date": date,
                    "edition": edition,
                }),
            }
        );

        const data = await getPdfAsHtml.json();
        
        if(data) {
            resolve(data.pdfHtmlData);
        }
        else {
            reject(false);
        }

    });

};

//let magazinBinarySource: any = null;

export const handleLinkPress = async (articleID: string, date: string | undefined, edition: string | undefined) => {

    if(date &&  edition) {
        useBoundStore.getState().updateArticleId(articleID);
        useBoundStore.getState().updateDate(date);
        useBoundStore.getState().updateEdition(edition);
        useBoundStore.getState().updateIsVisible(true);
    }

    return;

}; 

const MemoizedDocument = memo(function MemoizedDocument(props: {
    file: string,
    pageNumber: number,
    width: any,
    height: any,
    onGetAnnotationsSuccess: (annotations: any) => void,
}) {

    return (
        <View
            style={{
                width: props.width,
                height: props.height,
            }}
        >
            <View
                style={{
                    flex: 1,
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: props.width,
                    height: props.height,
                }}
            >
                <Document file={ props.file } options={ options }>
                    <Page 
                        pageNumber={ 1 } 
                        height={ props.height } 
                        onGetAnnotationsSuccess={ props.onGetAnnotationsSuccess }
                    />
                </Document>
            </View>  
        </View>
    );
    
});

export default function ViewerComponent(props: {
    magazineDataForViewer: Array<{
        pageTitle: string,
        pageNumber: string,
        pdfFile: string
    }>
}) {

    const user = usePersistSecureBoundStore(useCallback((state) => state.user, []));
    const currentMagazine = useBoundStore(useCallback((state) => state.magazine, []));
    const interstitialData = useBoundStore(useCallback((state) => state.interstitialData, []));

    const refContainer = useRef();

    const [visibleWidth, setVisibleWidth] = useState(0);
    const [visibleHeight, setVisibleHeight] = useState(0);

    const visibleWidthRef = useRef<any>(0);
    const visibleHeightRef = useRef<any>(0);

    const [currentIndex, setCurrentIndex] = useState(0);

    const [sliderRef, instanceRef] = useKeenSlider({
        slides: {
            origin: 'center',
            perView: 1,
            spacing: 0,
        },
        renderMode: 'performance',
        initial: 0,
        slideChanged(slider) {
            console.log('ViewerComponent.web.tsx - slider.track.details.rel', slider.track.details.rel);
            setCurrentIndex(slider.track.details.rel);
            useBoundStore.getState().updateCurrentPage((slider.track.details.rel + 1));
        },
    }, [MutationPlugin]);

    let pdfFiles = [];

    if(props.magazineDataForViewer) {

        const magazineDataForViewerLength = props.magazineDataForViewer.length;

        for(let a=0; a<magazineDataForViewerLength; a++) {
            pdfFiles.push(
                //`http://localhost:3758/protected-files/${currentMagazine?.date}/${currentMagazine?.edition}/${pageInfo[a].pageNumber}/${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${pageInfo[a].pageNumber}_0.pdf`
                props.magazineDataForViewer[a].pdfFile
            );
        }
    }

    if(currentMagazine?.pageInfo) {

        
    }

    const pageSelectionListener = (value: any) => {
        console.log('ViewerComponent.web.tsx - pageSelectionListener - value', value);
        useBoundStore.getState().updateCurrentPage(value);
        //updateCurrentPage(value);
        //setPageNumber(value); // This causes rerendering!
        instanceRef.current?.moveToIdx((value - 1));
    };
    
    removeAllEventListeners('PageSelectionByNavigation')
    addEventListener('PageSelectionByNavigation', pageSelectionListener);

    const handleLayout = (event: LayoutChangeEvent) => {
        
        const { width, height } = event.nativeEvent.layout;

        visibleWidthRef.current = width;
        visibleHeightRef.current = height;
        
        if(width != visibleWidth || height != visibleHeight) {
            setTimeout(() => {
                setVisibleWidth(width);
                setVisibleHeight(height);
            }, 100);
        }
        
    };

    const handleLinkClick = (event: any) => {
        event.preventDefault();
        const uri = event.target.href;

        if(typeof uri !== 'undefined') {
  
            if(uri.startsWith('http://article-')) {
                const articleID = uri.replace('http://article-', '').replace('/', '');
                handleLinkPress(articleID, currentMagazine?.date, currentMagazine?.edition);
            }
            else {
                if (interstitialData !== null) {
                    //trackMatomoInterstitial(`Interstitial`, "Klick", interstitialData.id)
                    //trackMatomoBrowsing(`Interstitial://${magazine.date}/${interstitialData.id}/Klick`)
                    //Linking.openURL(interstitialData.url);
                    
                }

                const newWindow = window.open(uri, '_blank', 'noopener,noreferrer')
                if (newWindow) {
                    newWindow.opener = null;
                }
            }
        }
    };

    const onGetAnnotationsSuccess = async (annotations: any) => {

        setTimeout(() => {
            for(const annotation of annotations) {
                const link = document.querySelectorAll("[data-annotation-id='" + annotation.id + "']");

                if(link.length > 0) {
                    link[0].addEventListener('click', handleLinkClick);
                }
                else {console.error("Couldn't find annotation with id: " + annotation.id);
                }
                
            } 
        }, 250);

    };

    const renderPDF = (pdf: string, index: number) => {

        const isVisible = true;
    
        return (
            <div 
                className={`keen-slider__slide number-slide${ index + 1 }`}
                key={`page_slide_${ index + 1 }`}
                style={{
                    background: 'grey',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: visibleHeightRef.current,
                    maxHeight: visibleHeightRef.current,
                    width: visibleWidthRef.current,
                    maxWidth: visibleWidthRef.current,

                }}
            >
                {isVisible ? (
                    <MemoizedDocument 
                        file={ pdf } 
                        pageNumber={ index + 1 } 
                        width={ visibleWidthRef.current } 
                        height={ visibleHeightRef.current } 
                        onGetAnnotationsSuccess={onGetAnnotationsSuccess}
                    />
                ) : (
                    <div>Loading...</div>
                )}
            </div>
        );
        

        
    }

    useFocusEffect(
        React.useCallback(() => {
            // Do something when the screen is focused
            console.log('ViewerComponent focus effect');
        
            return () => {
                // Do something when the screen is unfocused
                // Useful for cleanup functions
                console.log('ViewerComponent focus effect cleanup');
                instanceRef.current?.moveToIdx(0);
            };
        }, [])
    );
    
    
    useEffect(() => {
        instanceRef.current?.update();
    }, [visibleWidth, visibleHeight]);

    return (
        <View 
            style={{
                flex: 1,
                justifyContent: 'flex-start',
                flexDirection: 'row',
                width: '100%',
            }}

            //onContentSizeChange={handleContentSizeChange}
            onLayout={ handleLayout }
            ref={ refContainer }
        >
            <div 
                className="navigation-wrapper"
                style={{
                    width: visibleWidthRef.current,
                    maxWidth: visibleWidthRef.current,
                    height: visibleHeightRef.current,
                    margin: '0 auto'
                }}
            >
                <div ref={ sliderRef } className="keen-slider">
                    {
                        //props.pdfFiles.map((pdf: string, index: number) => renderPDF(pdf, index))
                        pdfFiles.map((pdf: string, index: number) => renderPDF(pdf, index))
                    }
                </div>
                <>
                    <SliderControlComponent 
                        instanceRef={ instanceRef }
                        numPages={ currentMagazine?.numberOfPages }
                    />
                </>
            </div>
        </View>
        
        
    );



}



export function OldViewerComponent() {

    

    //const { date, edition } = useLocalSearchParams();
    const user = usePersistSecureBoundStore(useCallback((state) => state.user, []));
    const currentMagazine = useBoundStore(useCallback((state) => state.magazine, []));
    const interstitialData = useBoundStore(useCallback((state) => state.interstitialData, []));
    //const updateCurrentPage = useBoundStore(useCallback((state) => state.updateCurrentPage, []));
    const updateNumberOfPages = useBoundStore(useCallback((state) => state.updateNumberOfPages, []));

    const [visibleWidth, setVisibleWidth] = useState(0);
    const [visibleHeight, setVisibleHeight] = useState(0);

    const visibleWidthRef = useRef<any>(0);
    const visibleHeightRef = useRef<any>(0);
    const refContainer = useRef();
    const [dimensions, setDimensions] = useState({
        width: 0,
        height: 0,
    });

    const [numPages, setNumPages] = useState(0);

    const [pdfData, setPdfData] = useState<Object | null>(null);
    const [pdfLoaded, setPdfLoaded] = useState(false);
    
    const [articleData, setArticleData] = useState<Object | null>(null);
    const [articleDataLoaded, setArticleDataLoaded] = useState(false);

    const [sliderLoaded, setSliderLoaded] = useState(false);
    const [slides, setSlides] = useState<any>([]);
    //const [currentSlide, setCurrentSlide] = useState(0);
    
    const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
        //initial: 1,
        renderMode: 'performance',
        //mode: "free",
        slides: {
            origin: 'center',
            //perView: 1,
        },
        slideChanged(slider) {
            emitEvent('PageChange', null);
            emitEvent('PageSelectionByViewer', (slider.track.details.rel + 1));
            //setCurrentSlide(slider.track.details.rel)
            //currentSlide = slider.track.details.rel;
            useBoundStore.getState().updateCurrentPage((slider.track.details.rel + 1));
            //updateCurrentPage((slider.track.details.rel + 1))
        },
        created() {
            setSliderLoaded(true)
        },
    }, [MutationPlugin]);


    const pageSelectionListener = (value: any) => {

        useBoundStore.getState().updateCurrentPage(value);
        //updateCurrentPage(value);
        //setPageNumber(value); // This causes rerendering!

        instanceRef.current?.moveToIdx((value - 1));

    };
    
    removeAllEventListeners('PageSelectionByNavigation')
    addEventListener('PageSelectionByNavigation', pageSelectionListener);


    // This callback gives you the height of the entire scrollable content.
    /*
    const handleContentSizeChange = (contentWidth: number, contentHeight: number) => {
        //console.log('contentHeight', contentHeight);
        setContentHeight(contentHeight);
    };
    */
    // This callback gives you the height of the visible ScrollView area (minus scrollbars).
    const handleLayout = (event: LayoutChangeEvent) => {
        const { width, height } = event.nativeEvent.layout;

        visibleWidthRef.current = width;
        visibleHeightRef.current = height;
        
        if(width != visibleWidth || height != visibleHeight) {
            setTimeout(() => {
                setVisibleWidth(width);
                setVisibleHeight(height);
            }, 100);
        }
    };

    const handleLinkClick = (event: any) => {
        event.preventDefault();
        const uri = event.target.href;

        if(typeof uri !== 'undefined') {
  
            if(uri.startsWith('http://article-')) {
                const articleID = uri.replace('http://article-', '').replace('/', '');
                //trackMatomoBrowsing(`Epaper://${magazine.edition}/${magazine.date}/Artikel/${articleID}`);
    
                //var JSONPath = `../epaper/${currentMagazine.date}/${currentMagazine.edition}/${currentMagazine.date}.ZEITUNG.${currentMagazine.edition}.ARTIKEL.json`;
                handleLinkPress(articleID, currentMagazine?.date, currentMagazine?.edition);
            }
            else {
                if (interstitialData !== null) {
                    //trackMatomoInterstitial(`Interstitial`, "Klick", interstitialData.id)
                    //trackMatomoBrowsing(`Interstitial://${magazine.date}/${interstitialData.id}/Klick`)
                    //Linking.openURL(interstitialData.url);
                    
                }

                const newWindow = window.open(uri, '_blank', 'noopener,noreferrer')
                if (newWindow) {
                    newWindow.opener = null;
                }
            }
        }
    };
  
    const onDocumentLoadSuccess = ({ numPages }: any) => {
        if(!pdfLoaded) {

        }
    };

      
    let pageRenderCnt = 1;
    
    const onRenderSuccess = async (index: number) => {

        pageRenderCnt++;

        if(pageRenderCnt === numPages) {
            console.info('Finished to render all pages!');
        }

        return;
    };

    let annotationRenderCnt = 1;

    const onRenderAnnotationLayerSuccess = async (index: number) => {

        annotationRenderCnt++;

        if(annotationRenderCnt === numPages) {
            console.info('Finished to render all annotations!');
        }

        return;

    };

    const onGetAnnotationsSuccess = async (annotations: any) => {

        setTimeout(() => {
            for(const annotation of annotations) {
                const link = document.querySelectorAll("[data-annotation-id='" + annotation.id + "']");

                if(link.length > 0) {
                    link[0].addEventListener('click', handleLinkClick);
                }
                else {
                    console.error("Couldn't find annotation with id: " + annotation.id);
                }
                
            } 
        }, 250);

    };

    // Memoize the PDF data
    const memoizedPdfData = useMemo(() => pdfData, [pdfData]);

    useEffect(() => {
        if(currentMagazine?.numberOfPages) {

            let slideItems = [];

            for(let a=1; a<=currentMagazine?.numberOfPages; a++) {
                slideItems.push({
                    edition: currentMagazine?.edition,
                    date: currentMagazine?.date,
                    pageNo: a,
                });

                if(a === currentMagazine?.numberOfPages) {
                    setSlides(slideItems);
                }
            }
        }
    }, [currentMagazine]);

    return (
        <View 
            style={{
                flex: 1,
                justifyContent: 'flex-start',
                //alignItems: 'center',
                flexDirection: 'row',

                width: '100%',


                //borderWidth: 1,
                //borderColor: 'yellow',
            }}

            //onContentSizeChange={handleContentSizeChange}
            onLayout={handleLayout}
            ref={ refContainer }
        >

            

            {currentMagazine && (


                <div 
                    className="navigation-wrapper"
                    style={{
                        width: visibleWidthRef.current,
                        height: visibleHeightRef.current,
                    }}
                >
                    <div ref={sliderRef} className="keen-slider">
                        {Array.from(
                            //new Array(numPages),
                            new Array(currentMagazine?.numberOfPages),
                            (el, index) => (

                                <div
                                    key={`page_slide_${index + 1}`} 
                                    className={`keen-slider__slide number-slide${index + 1}`}
                                >
                                    <View
                                        style={{
                                            //flex: 1,
                                            //flexDirection: 'row',

                                            //paddingHorizontal: pagePadding,
                                            width: visibleWidthRef.current,
                                            height: visibleHeightRef.current,


                                            //borderWidth: 1,
                                            //borderColor: 'red'
                                        }}
                                    >
                                        <View
                                            style={{
                                                flex: 1,
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                
                                                //paddingHorizontal: pagePadding,
                                                width: visibleWidthRef.current,
                                                height: visibleHeightRef.current,


                                                //borderWidth: 1,
                                                //borderColor: 'green'
                                            }}
                                        >

                                            <PDFSlideItem 
                                                key={`page_${index + 1}`}
                                                index={ index }
                                                edition={ currentMagazine?.edition }
                                                date={ currentMagazine?.date }
                                                pageNo={ index + 1 }
                                                visibleWidth={visibleWidthRef.current}
                                                visibleHeight={visibleHeightRef.current}
                                                pdfLoaded={pdfLoaded}
                                                sliderRef={sliderRef}
                                                onDocumentLoadSuccess={onDocumentLoadSuccess}
                                                onRenderSuccess={onRenderSuccess}
                                                onRenderAnnotationLayerSuccess={onRenderAnnotationLayerSuccess}
                                                onGetAnnotationsSuccess={onGetAnnotationsSuccess}
                                            />


                                            {
                                                /*
                                                    <Page 
                                                        //key={`page_${pageNumber}`}
                                                        //pageNumber={ pageNumber } 

                                                        key={`page_${pageNumber}`}
                                                        pageNumber={pageNumber}

                                                        height={ visibleHeightRef.current }
                                                        //width={404}
                                                        //height={ 500 }
                                                        onRenderSuccess={onRenderSuccess}

                                                    />
                                                */
                                            }

                                            {
                                                /*
                                                //useMemo(() => (
                                                    <>
                                                        <Suspense fallback={<h1>Still Loading…</h1>}>
                                                            <PageComponent
                                                                key={`page_${index + 1}`}
                                                                index={ index }
                                                                pageNumber={index + 1}

                                                                className={`page-number-${index + 1}`}

                                                                height={ visibleHeightRef.current }
                                                                onRenderSuccess={onRenderSuccess}
                                                                onRenderAnnotationLayerSuccess={onRenderAnnotationLayerSuccess}
                                                                onGetAnnotationsSuccess={onGetAnnotationsSuccess}
                                                            />
                                                        </Suspense>
                                                    </>
                                                //), [])
                                                */
                                            }

                                            
                                            
                                        </View>
                                        
                                    </View>
                                    
                                </div>
                            )
                        )}
                    </div>

                    {sliderLoaded && instanceRef.current && (
                        <>
                            <SliderControlComponent 
                                instanceRef={ instanceRef }
                                numPages={ currentMagazine?.numberOfPages }
                            />
                        </>
                    )}


                </div>
            
            )}

            

        </View>
    );

    const render = (
        
        <View 
            style={{
                flex: 1,
                justifyContent: 'flex-start',
                //alignItems: 'center',
                flexDirection: 'row',

                width: '100%',


                //borderWidth: 1,
                //borderColor: 'yellow',
            }}

            //onContentSizeChange={handleContentSizeChange}
            onLayout={handleLayout}
            ref={ refContainer }
        >

            

            {currentMagazine && (

                <Document 
                    //file={ magazineSource }
                    //file={{ data: magazinBinarySource }}
                    //file={ memoizedPdfData }
                    //source={{ uri: `${FileSystem.documentDirectory}/epaper/${currentMagazine.date}/${currentMagazine.edition}/${currentMagazine.date}.ZEITUNG.${currentMagazine.edition}.GESAMT.pdf` }}
                    file={ pdfUrl }
                    //file={ useCallback(() => { getMagazin }, []) }

                    //file={{ data: magazinBinarySource.pdfBinaryData }}

                    options={ options }

                    //onLoadSuccess={ useCallback(() => { onDocumentLoadSuccess }, []) }
                    onLoadSuccess={ onDocumentLoadSuccess }
                    onItemClick={(args)=> {
                        
                    }}
                    onLoadError={(error) => {
                        alert('Error while loading document! ' + error.message);
                    }}
                    onSourceError={(error) => {
                        alert('Error while retrieving document source! ' + error.message);
                    }}
                >
                    {pdfLoaded && (

                        <div 
                            className="navigation-wrapper"
                            style={{
                                width: visibleWidthRef.current,
                                height: visibleHeightRef.current,
                            }}
                        >
                            <div ref={sliderRef} className="keen-slider">
                                {Array.from(
                                    new Array(numPages),
                                    (el, index) => (

                                        <div
                                            key={`page_slide_${index + 1}`} 
                                            className={`keen-slider__slide number-slide${index + 1}`}
                                        >
                                            <View
                                                style={{
                                                    //flex: 1,
                                                    //flexDirection: 'row',

                                                    //paddingHorizontal: pagePadding,
                                                    width: visibleWidthRef.current,
                                                    height: visibleHeightRef.current,


                                                    //borderWidth: 1,
                                                    //borderColor: 'red'
                                                }}
                                            >
                                                <View
                                                    style={{
                                                        flex: 1,
                                                        flexDirection: 'row',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        
                                                        //paddingHorizontal: pagePadding,
                                                        width: visibleWidthRef.current,
                                                        height: visibleHeightRef.current,


                                                        //borderWidth: 1,
                                                        //borderColor: 'green'
                                                    }}
                                                >
                                                    {
                                                        /*
                                                            <Page 
                                                                //key={`page_${pageNumber}`}
                                                                //pageNumber={ pageNumber } 

                                                                key={`page_${pageNumber}`}
                                                                pageNumber={pageNumber}

                                                                height={ visibleHeightRef.current }
                                                                //width={404}
                                                                //height={ 500 }
                                                                onRenderSuccess={onRenderSuccess}

                                                            />
                                                        */
                                                    }

                                                    {
                                                        //useMemo(() => (
                                                            <>
                                                                <Suspense fallback={<h1>Still Loading…</h1>}>
                                                                    <PageComponent
                                                                        key={`page_${index + 1}`}
                                                                        index={ index }
                                                                        pageNumber={index + 1}

                                                                        className={`page-number-${index + 1}`}

                                                                        height={ visibleHeightRef.current }
                                                                        onRenderSuccess={onRenderSuccess}
                                                                        onRenderAnnotationLayerSuccess={onRenderAnnotationLayerSuccess}
                                                                        onGetAnnotationsSuccess={onGetAnnotationsSuccess}
                                                                    />
                                                                </Suspense>
                                                            </>
                                                        //), [])
                                                    }

                                                    
                                                    
                                                </View>
                                                
                                            </View>
                                            
                                        </div>
                                    )
                                )}
                            </div>
                            {
                                /*
                                <div ref={sliderRef} className="keen-slider">
                                {Array.from(
                                    new Array(numPages),
                                    (el, index) => (

                                        <div
                                            key={`page_slide_${index + 1}`} 
                                            className={`keen-slider__slide number-slide${index + 1}`}
                                        >
                                            <View
                                                style={{
                                                    //flex: 1,
                                                    //flexDirection: 'row',

                                                    //paddingHorizontal: pagePadding,
                                                    width: visibleWidthRef.current,
                                                    height: visibleHeightRef.current,


                                                    //borderWidth: 1,
                                                    //borderColor: 'red'
                                                }}
                                            >
                                                <View
                                                    style={{
                                                        flex: 1,
                                                        flexDirection: 'row',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        
                                                        //paddingHorizontal: pagePadding,
                                                        width: visibleWidthRef.current,
                                                        height: visibleHeightRef.current,


                                                        //borderWidth: 1,
                                                        //borderColor: 'green'
                                                    }}
                                                >
                                                    <Page 
                                                        //key={`page_${pageNumber}`}
                                                        //pageNumber={ pageNumber } 

                                                        key={`page_${index + 1}`}
                                                        pageNumber={index + 1}

                                                        height={ visibleHeightRef.current }
                                                        //width={404}
                                                        //height={ 500 }
                                                        onRenderSuccess={onRenderSuccess}

                                                    />
                                                </View>
                                                
                                            </View>
                                            
                                        </div>


                                        

                                        

                                    )
                                )}
                            </div>
                                */
                            }
                            

                            {sliderLoaded && instanceRef.current && (
                                <>
                                    <SliderControlComponent 
                                        instanceRef={ instanceRef }
                                        numPages={ numPages }
                                    />
                                </>
                            )}


                        </div>
                    
                    )}
                </Document>

            )}

            

        </View>

            
    );

    return render;
    

    return (
        
        <View 
            style={{
                flex: 1,
                justifyContent: 'flex-start',
                //alignItems: 'center',
                flexDirection: 'row',

                width: '100%',


                //borderWidth: 1,
                //borderColor: 'yellow',
            }}

            //onContentSizeChange={handleContentSizeChange}
            onLayout={handleLayout}
            ref={ refContainer }
        >



            {memoizedPdfData && (
                <Document 
                    //file={ magazineSource }
                    //file={{ data: magazinBinarySource }}
                    file={{ data: memoizedPdfData.data }}

                    //file={ useCallback(() => { getMagazin }, []) }

                    //file={{ data: magazinBinarySource.pdfBinaryData }}

                    //onLoadSuccess={ useCallback(() => { onDocumentLoadSuccess }, []) }
                    onLoadSuccess={ onDocumentLoadSuccess }
                    onItemClick={(args)=> {
                        
                    }}
                    onLoadError={(error) => {
                        alert('Error while loading document! ' + error.message);
                    }}
                    onSourceError={(error) => {
                        alert('Error while retrieving document source! ' + error.message);
                    }}
                >
                    {pdfLoaded && (

                        <div 
                            className="navigation-wrapper"
                            style={{
                                width: visibleWidthRef.current,
                                height: visibleHeightRef.current,
                            }}
                        >
                            <div ref={sliderRef} className="keen-slider">
                                {Array.from(
                                    new Array(numPages),
                                    (el, index) => (

                                        <div
                                            key={`page_slide_${index + 1}`} 
                                            className={`keen-slider__slide number-slide${index + 1}`}
                                        >
                                            <View
                                                style={{
                                                    //flex: 1,
                                                    //flexDirection: 'row',

                                                    //paddingHorizontal: pagePadding,
                                                    width: visibleWidthRef.current,
                                                    height: visibleHeightRef.current,


                                                    //borderWidth: 1,
                                                    //borderColor: 'red'
                                                }}
                                            >
                                                <View
                                                    style={{
                                                        flex: 1,
                                                        flexDirection: 'row',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        
                                                        //paddingHorizontal: pagePadding,
                                                        width: visibleWidthRef.current,
                                                        height: visibleHeightRef.current,


                                                        //borderWidth: 1,
                                                        //borderColor: 'green'
                                                    }}
                                                >
                                                    <Page 
                                                        key={`page_${index + 1}`}
                                                        pageNumber={index + 1} 
                                                        height={ visibleHeightRef.current }
                                                        //width={404}
                                                        //height={ 500 }
                                                        onRenderSuccess={onRenderSuccess}

                                                    />
                                                </View>
                                                
                                            </View>
                                            
                                        </div>


                                        

                                        

                                    )
                                )}
                            </div>

                            {sliderLoaded && instanceRef.current && (
                                <>
                                    <Arrow
                                        left
                                        onClick={(e: any) =>
                                            e.stopPropagation() || instanceRef.current?.prev()
                                        }
                                        disabled={currentSlide === 0}
                                    />

                                    <Arrow
                                        onClick={(e: any) =>
                                            e.stopPropagation() || instanceRef.current?.next()
                                        }
                                        
                                        disabled={
                                            //currentSlide === instanceRef.current?.track.details.slides.length - 1
                                            currentSlide === (numPages - 1)
                                        }
                                        //style={[styles.arrow]}
                                    />
                                </>
                            )}


                        </div>
                    
                    )}
                </Document>

            )}

            

            

        </View>

            
    );

};
